module.exports = __webpack_public_path__ + "assets/img/education_online_bg.52d06e60.png";